// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Partner_carouselSection__8hxq1 {
    padding: 4rem 0;
    background-color: #040404;
    overflow: hidden; 
  }
  
  .Partner_sectionTitle__1RHNh {
    text-align: center;
    margin-bottom: 2rem;
    font-size: 2rem;
    color: #333;
  }
  
  .Partner_carouselContainer__jmzFm {
    position: relative;
    width: 100%;
    overflow: hidden; 
    max-width: 1600px;
    margin: 0 auto;
  }
  
  .Partner_carouselContainer__jmzFm::before,
  .Partner_carouselContainer__jmzFm::after {
    content: '';
    position: absolute;
    top: 0;
    width: 20%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
  }
  
  .Partner_carouselContainer__jmzFm::before {
    left: 0;
    background: linear-gradient(to right, #040404 0%, rgba(4, 4, 4, 0) 100%);
  }
  
  .Partner_carouselContainer__jmzFm::after {
    right: 0;
    background: linear-gradient(to left, #040404 0%, rgba(4, 4, 4, 0) 100%);
  }
  
  .Partner_carouselTrack__Kv0UM {
    display: flex;
    will-change: transform;
    width: max-content; 
  }
  
  .Partner_partnerItem__v1LpD {
    flex: 0 0 auto;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .Partner_partnerLogo__H7GX2 {
    height: 28px;
    width: auto;
    opacity: 0.3;
    filter: grayscale(100%);
    transition: filter 0.3s ease;
  }
  
  .Partner_partnerLogo__H7GX2:hover {
    filter: grayscale(0%);
  }
  
  @media (max-width: 768px) {
    .Partner_partnerItem__v1LpD {
      padding: 0 1.5rem;
    }

  }`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/Sections/Partner/Partner.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,OAAO;IACP,wEAAwE;EAC1E;;EAEA;IACE,QAAQ;IACR,uEAAuE;EACzE;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,iBAAiB;IACnB;;EAEF","sourcesContent":[".carouselSection {\n    padding: 4rem 0;\n    background-color: #040404;\n    overflow: hidden; \n  }\n  \n  .sectionTitle {\n    text-align: center;\n    margin-bottom: 2rem;\n    font-size: 2rem;\n    color: #333;\n  }\n  \n  .carouselContainer {\n    position: relative;\n    width: 100%;\n    overflow: hidden; \n    max-width: 1600px;\n    margin: 0 auto;\n  }\n  \n  .carouselContainer::before,\n  .carouselContainer::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    width: 20%;\n    height: 100%;\n    z-index: 1;\n    pointer-events: none;\n  }\n  \n  .carouselContainer::before {\n    left: 0;\n    background: linear-gradient(to right, #040404 0%, rgba(4, 4, 4, 0) 100%);\n  }\n  \n  .carouselContainer::after {\n    right: 0;\n    background: linear-gradient(to left, #040404 0%, rgba(4, 4, 4, 0) 100%);\n  }\n  \n  .carouselTrack {\n    display: flex;\n    will-change: transform;\n    width: max-content; \n  }\n  \n  .partnerItem {\n    flex: 0 0 auto;\n    padding: 0 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .partnerLogo {\n    height: 28px;\n    width: auto;\n    opacity: 0.3;\n    filter: grayscale(100%);\n    transition: filter 0.3s ease;\n  }\n  \n  .partnerLogo:hover {\n    filter: grayscale(0%);\n  }\n  \n  @media (max-width: 768px) {\n    .partnerItem {\n      padding: 0 1.5rem;\n    }\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselSection": `Partner_carouselSection__8hxq1`,
	"sectionTitle": `Partner_sectionTitle__1RHNh`,
	"carouselContainer": `Partner_carouselContainer__jmzFm`,
	"carouselTrack": `Partner_carouselTrack__Kv0UM`,
	"partnerItem": `Partner_partnerItem__v1LpD`,
	"partnerLogo": `Partner_partnerLogo__H7GX2`
};
export default ___CSS_LOADER_EXPORT___;
